module.exports = __webpack_public_path__ + "img/Date-icon.c6cb49cb.svg";